import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { useRemoteConfigStore } from '@/shared/firebase';
import { useAccountStore } from '@/stores/account';
import { comexPendingOperationsService } from '../services/comexPendingOperations.service';

export const useComexPendingOperationsStore = defineStore(
  'comexPendingOperations',
  () => {
    const pendingOperationsCount = ref(0);

    const remoteConfigStore = useRemoteConfigStore();
    const accountStore = useAccountStore();

    const featureComex = remoteConfigStore.getRemoteConfigValue('feature_comex');

    const isComexAvailable = computed(() => {
      const isColombia =
        accountStore.kycStatus?.company?.addressCountry?.country === 'CO';
      const hasActivePurpose =
        accountStore.kycStatus?.company?.isComex === true;

      return featureComex.value && isColombia && hasActivePurpose;
    });

    async function fetchPendingOperations() {
      if (!isComexAvailable.value) {
        pendingOperationsCount.value = 0;
        return;
      }

      const response = await comexPendingOperationsService.getPendingOperations();

      response.fold(
        () => {
          pendingOperationsCount.value = 0;
        },
        (success) => {
          pendingOperationsCount.value =
            success.data[0]?.totalPendingOperations || 0;
        }
      );
    }

    function $reset() {
      pendingOperationsCount.value = 0;
    }

    return {
      pendingOperationsCount,
      fetchPendingOperations,
      isComexAvailable,
      $reset,
    };
  }
);
